import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  // 首页
  {
    path: '/',
    name: 'home',
    component: () => import('../views/index.vue')
  },
    // 首页
  {
    path: '/face',
    name: 'face',
    component: () => import('../views/face.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: '/',
  routes
})

export default router
